import { useState } from "react";
import { Row, Col, Card, Typography, Alert, Spin, Empty, Space, Switch } from "antd";
import { useCourses } from "@/api/catalog";
import { useMyMajors } from "@/api/enrollment";
import { CourseCard } from "@/components/CourseCard";
import { SuggestedCourses } from "@/components/SuggestedCourses";

const { Title, Paragraph } = Typography;

export function CourseList() {
  const [publishedOnly, setPublishedOnly] = useState(true);
  const { data, isLoading, error } = useCourses({
    published: publishedOnly ? true : undefined,
  });
  // Banner gợi ý chỉ hiện khi xác định được CHÍNH XÁC 1 ngành đang học — 0
  // hoặc nhiều ngành thì mơ hồ (không biết gợi ý theo ngành nào), sinh viên
  // tự vào trang chi tiết ngành (`/majors/:slug`) để xem gợi ý theo từng ngành.
  const { data: myMajors } = useMyMajors();
  const activeMajors = (myMajors ?? []).filter((m) => m.status === "enrolled");
  const soleActiveMajorId = activeMajors.length === 1 ? activeMajors[0].major.id : undefined;

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto" }}>
      {soleActiveMajorId !== undefined && (
        <SuggestedCourses majorId={soleActiveMajorId} variant="banner" />
      )}
      <Card>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                Môn học
              </Title>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                {data ? `${data.count} môn học` : "Đang tải..."}
              </Paragraph>
            </div>
            <Space>
              <span>Chỉ hiện đã publish:</span>
              <Switch
                checked={publishedOnly}
                onChange={setPublishedOnly}
                size="small"
              />
            </Space>
          </Space>

          {isLoading && (
            <div style={{ textAlign: "center", padding: 48 }}>
              <Spin size="large" />
              <div style={{ marginTop: 12, color: "#7a8499" }}>
                Đang tải môn học...
              </div>
            </div>
          )}

          {error && (
            <Alert
              type="error"
              showIcon
              message="Không tải được danh sách môn học"
              description={String(error)}
            />
          )}

          {data && data.results.length === 0 && (
            <Empty description="Chưa có môn học nào" />
          )}

          {data && data.results.length > 0 && (
            <Row gutter={[16, 16]}>
              {data.results.map((c) => (
                <Col key={c.id} xs={24} sm={12} md={8}>
                  <CourseCard course={c} />
                </Col>
              ))}
            </Row>
          )}
        </Space>
      </Card>
    </div>
  );
}

export default CourseList;
